export enum CustomerNoteType {
    INTERNAL = "internal",
    STANDARD = "standard"
}